
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Group 3221","xmlns":"http://www.w3.org/2000/svg","width":"80","height":"80","viewBox":"0 0 96.949 96.949"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 121108","d":"M0 0h96.949v96.949H0z","fill":"none"}}),_c('path',{attrs:{"data-name":"Path 121109","d":"M68.672 12.119L84.83 28.277","fill":"none","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"5"}}),_c('path',{attrs:{"data-name":"Path 121110","d":"M76.751 20.198L58.573 38.376","fill":"none","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"5"}}),_c('path',{attrs:{"data-name":"Path 121111","d":"M46.455 26.257l24.237 24.237","fill":"none","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"5"}}),_c('path',{attrs:{"data-name":"Path 121112","d":"M66.652 46.455L40.395 72.712H24.237V56.554l26.257-26.257","fill":"none","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"5"}}),_c('path',{attrs:{"data-name":"Path 121113","d":"M30.297 50.494l6.059 6.059","fill":"none","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"5"}}),_c('path',{attrs:{"data-name":"Path 121114","d":"M42.415 38.376l6.059 6.059","fill":"none","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"5"}}),_c('path',{attrs:{"data-name":"Path 121115","d":"M12.119 84.831l12.119-12.119","fill":"none","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"5"}})])
          )
        }
      }
    